import { micromodal } from "micromodal";

export function drawer() {
  MicroModal.init();

  const buttons = document.querySelectorAll(".js-drawerButton");
  const header = document.getElementById("js-header");

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const modal = button.nextElementSibling.id;
      const currentAriaExpanded = button.getAttribute("aria-expanded");

      if (currentAriaExpanded === "false") {
        button.setAttribute("aria-expanded", "true");
        MicroModal.show(modal, {
          disableScroll: true, // ページスクロールを無効に
          awaitOpenAnimation: true, // 開閉時のアニメーションを可能に
        });
        header.classList.add("is-open");
      } else {
        button.setAttribute("aria-expanded", "false");
        MicroModal.close(modal, {
          awaitCloseAnimation: true,
        });
        header.classList.remove("is-open");
      }
    });
  });

  // ドロワー内のリンククリック時にドロワーを閉じる処理を追加
  const drawerLinks = document.querySelectorAll(".c-drawer__link");
  
  drawerLinks.forEach((link) => {
    link.addEventListener("click", () => {
      // 現在開いているドロワーボタンを取得
      const openButton = document.querySelector(".js-drawerButton[aria-expanded='true']");
      
      if (openButton) {
        const modal = openButton.nextElementSibling.id;
        
        // ドロワーを閉じる
        openButton.setAttribute("aria-expanded", "false");
        MicroModal.close(modal, {
          awaitCloseAnimation: true,
        });
        header.classList.remove("is-open");
      }
    });
  });

  // 固定フッターのリンククリック時にドロワーを閉じる処理を追加
  const fixLinks = document.querySelectorAll(".c-fix__link");
  
  fixLinks.forEach((link) => {
    link.addEventListener("click", () => {
      // 現在開いているドロワーボタンを取得
      const openButton = document.querySelector(".js-drawerButton[aria-expanded='true']");
      
      if (openButton) {
        const modal = openButton.nextElementSibling.id;
        
        // ドロワーを閉じる
        openButton.setAttribute("aria-expanded", "false");
        MicroModal.close(modal, {
          awaitCloseAnimation: true,
        });
        header.classList.remove("is-open");
      }
    });
  });
}